import {Box} from '@mui/material';
import {Outlet, useLocation} from 'react-router-dom';

import KycStepLoader from '@/app/main/onboarding/pages/kyc/components/KycStepLoader/KycStepLoader';
import useWindowSize from '@/hooks/WindowSize/WindowSize';

import useBlockOnboardingBrowserNavigation from './hooks/useBlockOnboardingBrowserNavigation';
import {
  OnboardingViewModelContext,
  useOnboardingContext,
} from './ViewModelContext';

const OnboardingPageContent = () => {
  const location = useLocation().pathname;
  const {isMobile} = useWindowSize();
  const {isLoadingFeatureFlags} = useOnboardingContext();
  const isOnboardingRoot = location === '/onboarding';
  const shouldShowLoader = isLoadingFeatureFlags || isOnboardingRoot;

  useBlockOnboardingBrowserNavigation();

  return (
    <Box
      sx={{
        paddingTop: isMobile ? 3 : 4,
        paddingBottom: 16,
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Box
        component="img"
        src="/assets/images/logo/logo-text-black.svg"
        alt="Modak"
        sx={{
          width: '128px',
          height: '24px',
          marginTop: '16px',
          alignSelf: 'center',
        }}
      />

      {shouldShowLoader ? <KycStepLoader /> : <Outlet />}
    </Box>
  );
};

const OnboardingPage = () => (
  <OnboardingViewModelContext>
    <OnboardingPageContent />
  </OnboardingViewModelContext>
);

export default OnboardingPage;
